import React, { useState } from "react";
import { Button, Box, Typography } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { setAuthToken } from "../../../utils/setAuthToken";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const ImageUploadButton = ({ onImageUpload }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedImage(file);
  };

  const handleUpload = () => {
    // Perform image upload logic here (e.g., using Axios, Fetch, or any other library)
    // Pass the selectedImage to the parent component using onImageUpload callback
    if (selectedImage) {
      const formData = new FormData();
      formData.append("file", selectedImage);
      setAuthToken(localStorage.getItem("jwtToken"));
      axios
        .post(
          "https://api.blockpay.co.za/merchant/updateProfilePic",
          formData
        )
        .then((res) => {
          toast.success(res.data.message);
          console.log(res);
          window.location.reload();
        })
        .catch((err) => {
          toast.error(err.response.data.message);
          console.log(err);
          if (err.response.data.message === "Unauthorized!") {
            axios
              .post("https://api.blockpay.co.za/auth/refreshToken", {
                refreshToken: localStorage.getItem("refreshToken"),
              })
              .then((res) => {
                console.log(res);
                localStorage.setItem("jwtToken", res.data.accessToken);
                setTimeout(() => {
                  window.location.reload();
                }, 500);
              })
              .catch((err) => {
                console.log(err);
                localStorage.clear();
                window.location.reload();
              });
          }
        });
    }
  };

  return (
    <div>
      <ToastContainer />
      <input
        accept=".png, .jpg, .jpeg"
        style={{ display: "none" }}
        id="image-upload-input"
        type="file"
        onChange={handleFileChange}
      />
      <label htmlFor="image-upload-input">
        <Button
          variant="contained"
          color="primary"
          component="span"
          startIcon={<CloudUploadIcon />}
          className="loginButtonSignUp"
        >
          Upload Image
        </Button>
      </label>
      {selectedImage && (
        <Box sx={{ mt: "1rem" }}>
          <Typography sx={{ width: "100%!important", mt: "1rem" }}>
            Selected Image: {selectedImage.name}
          </Typography>
          <Button
            className="loginButtonSignUp"
            variant="contained"
            color="secondary"
            onClick={handleUpload}
          >
            Confirm
          </Button>
        </Box>
      )}
    </div>
  );
};

export default ImageUploadButton;
